// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + ({"98":"ErrorPage","332":"Post","362":"Dashboard"}[chunkId] || chunkId) + "." + {"98":"60400351","332":"682b423c","362":"e0027b09","595":"2d0cd54a","640":"42fcf04e"}[chunkId] + ".chunk.js";
};